import { CustomCellDate, InnerCrudLink } from "@/shared/components";
import { Chip } from "@mui/material";
import type { TagTypesListRow } from "@/admin/entities/tagTypes";
import type { TagTypesListQueryType } from "@/types/graphql/admin.generated";

/**
 * Конфигурация для InnerCRUD типов тегов организаций
 */

// Трансформация данных GraphQL ответа в формат для таблицы
export function getTableData(data: unknown): {
  nodes: TagTypesListRow[];
  count: number;
} {
  const typedData = data as TagTypesListQueryType;
  const res = typedData?.tagTypes;

  if (!res || !res.nodes) {
    return { nodes: [], count: 0 };
  }

  return {
    nodes: res.nodes,
    count: res.count,
  };
}

// Маппинг данных типа тега в формат для отображения в таблице
export function mapColumns(tagType: TagTypesListRow) {
  return [
    tagType.id,
    tagType, // для кастомного рендера названия
    tagType.featured,
    tagType.seoDescription,
    tagType.createdAt,
  ];
}

// Конфигурация колонок таблицы
export const getColumnsConfig = () => [
  { name: "id", label: "ID", options: { display: false, filter: false } },
  {
    name: "title",
    label: "Название",
    options: {
      customBodyRender: (data: unknown) => {
        const tagType = data as TagTypesListRow;
        return <InnerCrudLink id={tagType.id}>{tagType.title}</InnerCrudLink>;
      },
    },
  },
  {
    name: "featured",
    label: "Featured",
    options: {
      customBodyRender: (value: unknown) => {
        if (value) {
          return (
            <Chip
              label="Featured"
              color="primary"
              size="small"
              variant="filled"
            />
          );
        }
        return null;
      },
    },
  },
  {
    name: "seoDescription",
    label: "SEO",
    options: {
      customBodyRender: (value: unknown) => {
        if (value) {
          return (
            <Chip
              label="В описании"
              color="default"
              size="small"
              variant="outlined"
            />
          );
        }
        return null;
      },
    },
  },
  {
    name: "createdAt",
    label: "Дата создания",
    options: {
      setCellHeaderProps: () => ({ style: { width: 150 } }),
      customBodyRender: (value: unknown) => (
        <CustomCellDate date={value as string} />
      ),
    },
  },
];

// Конфигурация текстов интерфейса
export const getTextsConfig = () => ({
  filterTitle: "Фильтры",
  listTitle: "Типы тегов",
  itemCreated: "Тип тега создан",
  itemUpdated: "Тип тега обновлен",
  createItem: "Создать тип тега",
  refetchList: "Обновить список",
  deleteItems: "Удалить типы тегов",
  itemsDeleted: "Типы тегов удалены",
  itemsRestored: "Типы тегов восстановлены",
  restoreItems: "Восстановить типы тегов",
  cancel: "Отмена",
  editItem: "Тип тега",
  showTitle: "Детали",
});
